import React, { useState } from "react";
import "../styles/sobre.css";
import SimuladorFrete from "components/SimuladorFrete";

export default function SobreIntrex() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const whatsappLink = "https://wa.me/5547992104226?text=Quero%20saber%20mais%20sobre%20a%20INTREX";

  const trackWhatsAppClick = (location: string) => {
    if (typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'Contact', {
        content_name: 'WhatsApp Click',
        content_category: 'Lead Generation',
        content_location: location
      });
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqList = [
    {
      question: "Como funciona o desconto de até 90%?",
      answer: "A Intrex possui acordos diretos com FedEx e UPS. Ao centralizar o volume de todos os nossos clientes, negociamos tabelas que um e-commerce sozinho jamais conseguiria — e repassamos essa economia integralmente para você.",
    },
    {
      question: "Para quais países vocês enviam?",
      answer: "Atendemos mais de 200 países e territórios, incluindo Estados Unidos, Europa, Ásia, Oceania e toda a América Latina. Se o destino existir no mapa, provavelmente já enviamos para lá.",
    },
    {
      question: "Qual suporte vocês oferecem?",
      answer: "Oferecemos suporte via chat, WhatsApp e e-mail, com especialistas em logística internacional prontos para ajudar.",
    },
    {
      question: "Quais são as formas de pagamento?",
      answer: "Aceitamos cartão de crédito, PIX e faturamento mensal para clientes corporativos.",
    },
    {
      question: "Posso enviar sem ter uma loja virtual?",
      answer: "Sim! Nossa plataforma atende tanto pessoas jurídicas quanto físicas que precisam fazer envios internacionais.",
    },
    {
      question: "Quais plataformas de e-commerce consigo integrar?",
      answer: "Integração nativa com Shopify, WooCommerce, Nuvemshop e API aberta para qualquer sistema personalizado.",
    },
    {
      question: "Quanto tempo leva para começar a usar?",
      answer: "O cadastro é imediato. Após validação (até 2h úteis), você já pode cotar e gerar etiquetas.",
    },
  ];

  const logos = [
    { src: "/images/logo.movie.png", alt: "Movie Fitness" },
    { src: "/images/logo-monte-leste.png", alt: "Monte Leste" },
    { src: "/images/logo-gatza.png", alt: "Gatza" },
    { src: "/images/logo-baddoria.png", alt: "Baddoria" },
    { src: "/images/fallen.png", alt: "Fallen" },
  ];

  return (
    <main className="sobre">
      <header className="sobre-nav">
        <div className="sobre-nav__pill">
          <div className="sobre-nav__left">
            <a href="/" className="sobre-nav__logo-wrapper">
              <img src="/images/intrex_logo.png" alt="INTREX" className="sobre-nav__logo-img" />
            </a>
          </div>

          <nav className={`sobre-nav__center ${menuOpen ? "is-active" : ""}`}>
            <a className="sobre-nav__link" href="#como-funciona" onClick={() => setMenuOpen(false)}>Como funciona</a>
            <a className="sobre-nav__link" href="#simulacao" onClick={() => setMenuOpen(false)}>Simulação</a>
            <a className="sobre-nav__link" href="#porque" onClick={() => setMenuOpen(false)}>Diferenciais</a>
            <a className="sobre-nav__link" href="#faq" onClick={() => setMenuOpen(false)}>Dúvidas</a>
            <a className="sobre-nav__login mobile-only" href="/login">Fazer login</a>
          </nav>

          <div className="sobre-nav__right">
            <a className="sobre-nav__login desktop-only" href="/login">Fazer login</a>
            <a 
              className="sobre-nav__cta-pill" 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick('Navbar')}
            >
              Vamos Conversar
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <path d="M9 18l6-6-6-6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <button className="sobre-nav__toggle" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>
      </header>

      <section className="sobre-section sobre-hero">
        <div className="sobre-hero__container">
          <div className="sobre-hero__left">
            <div className="sobre-hero__kicker">INTREX</div>
            <h1 className="sobre-hero__title">
              Conecta você <br /> Ao <span className="sobre-hero__accent">mundo</span>
            </h1>
            <p className="sobre-hero__subtitle">
              Sistema de logística que conecta sua loja do Brasil a mais de <strong>200 países</strong> com
              até <strong>90% de desconto</strong> sobre tabela pública da FedEx e UPS.
            </p>
            <div className="sobre-hero__actions">
              <a
                className="btn-primary"
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsAppClick('Hero Section')}
              >
                Quero utilizar
              </a>
              <a className="btn-simular-hero" href="#simulacao">Simular meu frete</a>
              <a className="btn-link" href="#porque">Por que nos escolher?</a>
            </div>
            <div className="sobre-hero__stats">
              <div className="sobre-hero__stat">
                <span className="stat-num">+200</span>
                <span className="stat-label">países atendidos</span>
              </div>
              <div className="sobre-hero__stat">
                <span className="stat-num">90%+</span>
                <span className="stat-label">de desconto</span>
              </div>
              <div className="sobre-hero__stat">
                <span className="stat-num">4 cliques</span>
                <span className="stat-label">para cotar</span>
              </div>
            </div>
          </div>
          <div className="sobre-hero__right">
            <div className="sobre-hero__mock">
              <img src="/images/intrex-dashboard.png" alt="Dashboard" loading="eager" />
            </div>
          </div>
        </div>
      </section>

      <SimuladorFrete whatsappLink={whatsappLink} onContato={trackWhatsAppClick} />

      <section className="sobre-section sobre-marcas">
        <div className="sobre-marcas__wrapper">
          <div className="sobre-marcas__sidebar">
            <p className="sobre-marcas__text">Marcas brasileiras<br />que conquistaram o<br />mundo com a Intrex</p>
          </div>
          <div className="sobre-marcas__slider">
            <div className="sobre-marcas__track">
              {[...logos, ...logos, ...logos, ...logos].map((logo, index) => (
                <div key={index} className="sobre-marcas__item">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="sobre-section sobre-funciona" id="como-funciona">
        <div className="sobre-funciona__container">
          <div className="sobre-funciona__header">
            <span className="sobre-funciona__kicker">COTAÇÃO EM 4 CLIQUES</span>
            <h2 className="sobre-funciona__title">Como funciona</h2>
          </div>
          <div className="sobre-funciona__grid">
            <div className="sobre-funciona__item">
              <div className="sobre-funciona__icon"><img src="/images/icon-shop.png" alt="Loja" /></div>
              <h3>Conecte sua loja</h3>
              <p>Integre seu Shopify ou e-commerce em poucos cliques. A configuração leva menos de 5 minutos.</p>
            </div>
            <div className="sobre-funciona__item">
              <div className="sobre-funciona__icon"><img src="/images/icon-calc.png" alt="Simulação" /></div>
              <h3>Simule e gere envios</h3>
              <p>Compare opções de frete com nossas taxas negociadas e crie envios automaticamente.</p>
            </div>
            <div className="sobre-funciona__item">
              <div className="sobre-funciona__icon"><img src="/images/icon-docs.png" alt="Documentos" /></div>
              <h3>Documentos automáticos</h3>
              <p>Commercial Invoice, AWB e etiquetas são gerados automaticamente para cada remessa.</p>
            </div>
            <div className="sobre-funciona__item">
              <div className="sobre-funciona__icon"><img src="/images/icon-track.png" alt="Acompanhe" /></div>
              <h3>Acompanhe tudo</h3>
              <p>Rastreie todos os envios em tempo real, receba alertas e mantenha seus clientes informados.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sobre-section sobre-para-quem" id="porque">
        <div className="sobre-para-quem__container">
          <div className="sobre-para-quem__content">
            <span className="sobre-para-quem__kicker">PARA QUEM É</span>
            <h2 className="sobre-para-quem__title">Feita para quem quer <span className="highlight">vender<br />para o mundo</span></h2>
            <p className="sobre-para-quem__desc">A Intrex foi desenvolvida para empresas brasileiras que querem expandir suas vendas internacionais com eficiência e economia.</p>
            <ul className="sobre-para-quem__list">
              <li><div className="dot"></div><div><strong>E-commerces que já exportam</strong><p>Lojas que vendem para EUA, Europa e Ásia e querem parar de pagar tabela pública.</p></div></li>
              <li><div className="dot"></div><div><strong>Marcas DTC com alcance global</strong><p>Quem vende direto ao consumidor final em qualquer um dos +200 países que atendemos.</p></div></li>
              <li><div className="dot"></div><div><strong>Operações Shopify e WooCommerce</strong><p>Integração nativa: pedido confirmado, etiqueta gerada, envio rastreado — automático.</p></div></li>
              <li><div className="dot"></div><div><strong>Quem ainda paga tabela cheia</strong><p>Se você cota direto com FedEx ou UPS, está deixando até 90% de desconto na mesa.</p></div></li>
            </ul>
          </div>
          <div className="sobre-para-quem__image"><img src="/images/mapa-brasil-mundo.png" alt="Mapa" /></div>
        </div>
      </section>

      <section className="sobre-section sobre-plataforma">
        <div className="sobre-plataforma__container">
          <div className="sobre-plataforma__header">
            <h2 className="sobre-plataforma__title">Não somos apenas intermediários.<br /><span className="highlight">Somos sua plataforma logística.</span></h2>
            <p className="sobre-plataforma__subtitle">A Intrex oferece acordos diretos com transportadoras e tecnologia própria.</p>
          </div>
          <div className="sobre-plataforma__grid">
            <div className="sobre-plataforma__card">
              <div className="card-icon"><img src="/images/icon-tech.png" alt="Tech" /></div>
              <h3>Tecnologia própria</h3>
              <p>Sistema desenvolvido internamente, com total controle sobre funcionalidades.</p>
            </div>
            <div className="sobre-plataforma__card">
              <div className="card-icon"><img src="/images/icon-shield.png" alt="Acordos" /></div>
              <h3>Acordos diretos</h3>
              <p>Negociações diretas com FedEx e UPS garantem até 90% de desconto sobre as tabelas públicas.</p>
            </div>
            <div className="sobre-plataforma__card">
              <div className="card-icon"><img src="/images/icon-scale.png" alt="Escala" /></div>
              <h3>Escalabilidade</h3>
              <p>Infraestrutura preparada para crescer com seu negócio.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="sobre-section sobre-faq" id="faq">
        <div className="sobre-faq__container">
          <div className="sobre-faq__left"><h2 className="sobre-faq__title">Alguma dúvida?<br /><span className="sobre-faq__subtitle">Aqui estão as respostas</span></h2></div>
          <div className="sobre-faq__right">
            {faqList.map((item, index) => (
              <div key={index} className={`sobre-faq__item ${openFaq === index ? "active" : ""}`} onClick={() => toggleFaq(index)}>
                <div className="sobre-faq__question"><span className="faq-icon">{openFaq === index ? "−" : "+"}</span><h3>{item.question}</h3></div>
                <div className="sobre-faq__answer"><p>{item.answer}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sobre-section sobre-cta-final">
        <div className="sobre-cta-final__container">
          <div className="sobre-cta-final__banner">
            <div className="sobre-cta-final__content">
              <h2>Você chegou no fim da página</h2>
              <p>Se chegou até aqui, é porque ta interessado. Então vai, entra logo em contato.</p>
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-cta-white"
                onClick={() => trackWhatsAppClick('CTA Final')}
              >
                Começar agora
              </a>
            </div>
            <div className="sobre-cta-final__image"><img src="/images/cta-globo-final.png" alt="Globo" /></div>
          </div>
        </div>
      </section>

      <footer className="sobre-footer">
        <div className="sobre-footer__container">
          <div className="sobre-footer__top">
            <div className="sobre-footer__col">
              <a href="/" className="sobre-footer__logo"><img src="/images/intrex_logo.png" alt="INTREX" /></a>
              <p>Conectando sua loja ao mundo com eficiência, tecnologia e as melhores taxas do mercado.</p>
            </div>
            <div className="sobre-footer__col">
              <h4>Navegação</h4>
              <nav className="sobre-footer__nav">
                <a href="#como-funciona">Como funciona</a>
                <a href="#simulacao">Simulação</a>
                <a 
                  href={whatsappLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  onClick={() => trackWhatsAppClick('Footer Link')}
                >
                  Falar com especialista
                </a>
              </nav>
            </div>
            <div className="sobre-footer__col">
              <h4>Contato</h4>
              <div className="sobre-footer__contact">
                <p>contato@exportadigital.com</p>
                <p>+55 (47) 99210-4226</p>
                <p>Florianópolis, SC - Brasil</p>
              </div>
            </div>
          </div>
          <div className="sobre-footer__bottom">
            <p>&copy; 2026 Intrex. Todos os direitos reservados.</p>
            <div className="sobre-footer__legal"><a href="#">Termos de Uso</a><a href="/privacy-policy">Privacidade</a></div>
          </div>
        </div>
      </footer>
    </main>
  );
}